// @ts-expect-error untyped import
import { useCurrentUser } from '../../access/useUserInfo';
const REALM_KEY = 'ReportingAssetManagement';
const hasRealmAccess = () => {
  try {
    const value = localStorage.getItem(REALM_KEY);
    return !!value;
  } catch (e) {
    return false;
  }
};
export const useHasRealmActionAccess = () => {
  var _userData$get;
  const userData = useCurrentUser();
  const hasTemplateCreateAccess = hasRealmAccess();
  const isHubspotter = userData === null || userData === void 0 || (_userData$get = userData.get('email')) === null || _userData$get === void 0 ? void 0 : _userData$get.includes('@hubspot.com');
  return isHubspotter && hasTemplateCreateAccess;
};